// 通用配置服务
import { httpClient } from './httpClient';

export interface CommonConfig {
  id?: number;
  configKey: string;
  configValue: string;
  configType: string;
  configDesc?: string;
  sortOrder?: number;
  status?: string;
  createBy?: string;
  createTime?: string;
  updateBy?: string;
  updateTime?: string;
  remark?: string;
}

export interface CommonConfigQuery {
  configKey?: string;
  configValue?: string;
  configType?: string;
  configName?: string;
  status?: string;
  current?: number;
  size?: number;
  exactMatch?: boolean;
}

// 获取通用配置列表
export const getList = (params: CommonConfigQuery) => {
  return httpClient.get('/api/biz/common-config/list', { params });
};

// 获取通用配置详情
export const getDetail = (id: number) => {
  return httpClient.get(`/api/biz/common-config/${id}`);
};

// 新增通用配置
export const create = (data: CommonConfig) => {
  return httpClient.post('/api/biz/common-config', data);
};

// 更新通用配置
export const update = (data: CommonConfig) => {
  return httpClient.put('/api/biz/common-config', data);
};

// 删除通用配置
export const remove = (ids: number[]) => {
  return httpClient.delete(`/api/biz/common-config/${ids.join(',')}`);
};

// 根据配置键获取配置
export const getByKey = (configKey: string) => {
  return httpClient.get(`/api/biz/common-config/key/${configKey}`);
};

// 根据配置类型获取配置列表
export const getByType = (configType: string) => {
  return httpClient.get(`/api/biz/common-config/type/${configType}`);
};

// 批量更新配置
export const updateBatch = (configs: CommonConfig[]) => {
  return httpClient.put('/api/biz/common-config/batch', configs);
};

// 默认导出所有服务方法
const commonConfigService = {
  getList,
  getDetail,
  create,
  update,
  remove,
  getByKey,
  getByType,
  updateBatch
};

export default commonConfigService;
